module.exports = __webpack_public_path__ + "img/black_star_icon.9e8bc9fd.svg";